import { render, staticRenderFns } from "./SpecAutocompleteMultiple.vue?vue&type=template&id=52a2c273"
import script from "./SpecAutocompleteMultiple.vue?vue&type=script&lang=js"
export * from "./SpecAutocompleteMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports